<template>
  <v-container
    fluid
    fill-height
  >
    <v-card
      outlined
      class="mx-auto"
      style="width: 40rem;"
    >
      <v-card-title class="justify-center">
        <h2 class="text-center">
          送信が完了しました。
        </h2>
      </v-card-title>
      <v-card-text>
        <p>
          招待ページへのリンクを記載したURLお送りしました。
          <br>
          招待メール又はSMSが届かない場合は、迷惑メールボックスの設定解除、ドメイン着信許可の設定をご確認ください。
        </p>
      </v-card-text>
      <v-card-text>
        <div class="text-center">
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'EmissionInvitationCompleted',
    mixins: [],
    props: {},
    computed: {},
    methods: {}
  }
</script>

<style scoped>

</style>
